import { tv } from 'tailwind-variants'

import { StatusBadge, statusBadgeVariants } from '@/components/ui'
import { STATEMENT_STATUSES } from '@/modules/projects/constants'
import { humanizeText } from '@/utils'
import {
  PROJECT_ANIMATED_STATUSES,
  PROJECT_STATUS_SLOTS,
} from './ProjectStatusBadge'

const statementStatusBadgeVariants = tv({
  extend: statusBadgeVariants,
  variants: {
    status: {
      ...PROJECT_STATUS_SLOTS,
      [STATEMENT_STATUSES.enqueued]: {
        base: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100',
        dot: 'bg-amber-500',
        icon: 'text-amber-500',
      },
      [STATEMENT_STATUSES.segmenting]: {
        base: 'bg-sky-50 text-sky-700 border-sky-200 hover:bg-sky-100',
        dot: 'bg-sky-500',
        icon: 'text-sky-500',
      },
      [STATEMENT_STATUSES.recognizing]: {
        base: 'bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100',
        dot: 'bg-indigo-500',
        icon: 'text-indigo-500',
      },
      [STATEMENT_STATUSES.extracting]: {
        base: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
        dot: 'bg-blue-500',
        icon: 'text-blue-500',
      },
      [STATEMENT_STATUSES.categorizing]: {
        base: 'bg-violet-50 text-violet-700 border-violet-200 hover:bg-violet-100',
        dot: 'bg-violet-500',
        icon: 'text-violet-500',
      },
      [STATEMENT_STATUSES.duplicated]: { base: '', dot: '' },
    },
  },
})

const STATEMENT_ANIMATED_STATUSES: string[] = [
  ...PROJECT_ANIMATED_STATUSES,
  STATEMENT_STATUSES.segmenting,
  STATEMENT_STATUSES.recognizing,
  STATEMENT_STATUSES.extracting,
  STATEMENT_STATUSES.categorizing,
]

interface StatementStatusBadgeProps {
  status?: string
  className?: string
  showLabel?: boolean
}

export const StatementStatusBadge = ({
  status,
  className,
  showLabel,
}: StatementStatusBadgeProps) => {
  return (
    <StatusBadge
      slots={statementStatusBadgeVariants({ status })}
      label={humanizeText(status ?? '')}
      animated={!!status && STATEMENT_ANIMATED_STATUSES.includes(status)}
      className={className}
      showLabel={showLabel}
    />
  )
}
